import React, { useState } from "react";
import { useServiceRequestSearch } from "../../hooks/useServiceRequestSearch";
import { useNavigate } from "react-router-dom";
import RequestsSearchBar from "../../components/service-request-components/ServiceRequestSearchBar";
import "../../css/jobs.css";
import { getImage } from "../../utils/cloudinarySizing";


const ServiceRequests = () => {
    const navigate = useNavigate();

    const {
        jobs,
        loading,
        totalCount,
        search,
        page,
        goToPage,
        formatDate,
        formatBudget,
        likedJobs,
        feedbackJob,
        hoveredJobId,
        setHoveredJobId,
        handleToggleLike,
        handleSearch
    } = useServiceRequestSearch(10);

    const [brokenImages, setBrokenImages] = useState({});

    const handleJobClick = (id) => navigate(`/service-requests/${id}`);

    const getJobImage = (job) => {
        return job.images?.[0]?.image || null;
    };

    const formatLocation = (job) => {
        if (!job) return "Not Available";

        const parts = [];
        if (job.city) parts.push(job.city);
        if (job.state) parts.push(job.state);
        if (job.country && job.country !== "US") parts.push(job.country);

        return parts.length > 0 ? parts.join(", ") : "Not Available";
    };

    const renderPagination = () => {
        const totalPages = Math.ceil(totalCount / 10);
        if (totalPages <= 1) return null;

        return (
            <div className="pagination-container">
                {Array.from({ length: totalPages }, (_, i) => (
                    <button
                        key={i + 1}
                        className={`pagination-btn ${i + 1 === page ? "active" : ""}`}
                        onClick={() => goToPage(i + 1)}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>
        );
    };

    return (
        <div id="content-scroll" key={search}>
            <div className="jobs-page-wrapper">
                <div className="jobs-page-mainchat" key={page}>

                    {loading && jobs.length === 0 ? (
                        <div className="profile-spinner-container">
                            <div className="centered-content">
                                <div className="profile-spinner-wrapper">
                                    <div className="profile-spinner"></div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="jobs-page-feed">

                            {jobs.length === 0 ? (
                                <p className="text-gray-500">
                                    No service requests found.
                                </p>
                            ) : (
                                jobs.map((job, index) => {
                                    const imageUrl = getJobImage(job);
                                    const isBroken = brokenImages[job.id];

                                    return (
                                        <div
                                            key={job.id || index}
                                            onClick={() => handleJobClick(job.id)}
                                            style={{ "--i": index }}
                                        >
                                            <div className="jobs-page-item fade-in">

                                                {imageUrl && !isBroken ? (
                                                    <img
                                                        src={getImage(imageUrl, "srv_sm")}
                                                        alt="Job preview"
                                                        className="jobs-page-image"
                                                        onError={() => {
                                                            setBrokenImages((prev) => ({
                                                                ...prev,
                                                                [job.id]: true
                                                            }));
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="jobs-page-placeholder">
                                                        <span>No Image</span>
                                                    </div>
                                                )}
                                                <div className="jobs-page-details">
                                                    <h3 className="jobs-page-title">
                                                        {job.title}
                                                    </h3>

                                                    <p className="jobs-page-description">
                                                        {job.description}
                                                    </p>

                                                    <p className="jobs-page-info">
                                                        <strong>Pay:</strong>{" "}
                                                        <i className="fas fa-dollar-sign money-icon"></i>{" "}
                                                        {formatBudget(job)} / {job.budget_type}

                                                        <span className="separator">|</span>

                                                        <i className="fas fa-location-dot location-icon"></i>{" "}
                                                        <strong>Location:</strong>{" "}
                                                        {formatLocation(job)}
                                                    </p>
                                                </div>

                                                <div className="jobs-page-item-date">
                                                    {formatDate(job.created_at)}
                                                </div>

                                                <div
                                                    className="heart-icon"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleToggleLike(job.id);
                                                    }}
                                                    onMouseEnter={() => setHoveredJobId(job.id)}
                                                    onMouseLeave={() => setHoveredJobId(null)}
                                                >
                                                    <i
                                                        className="fas fa-heart"
                                                        style={{
                                                            color:
                                                                likedJobs[job.id] ||
                                                                    hoveredJobId === job.id
                                                                    ? "red"
                                                                    : "#ccc",
                                                            transition: "color 0.2s ease",
                                                        }}
                                                    />

                                                    {feedbackJob?.id === job.id && (
                                                        <span className="heart-feedback show">
                                                            {feedbackJob.text}
                                                        </span>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    )}

                    {renderPagination()}
                </div>

                <div className="requests-search-bar-wrapper">
                    <div className="requests-search-center">
                        <p className="jobs-page-results">
                            {totalCount > 0 ? `${totalCount} ` : 0} result
                            {totalCount !== 1 ? "s" : ""}
                        </p>

                        <RequestsSearchBar onSearch={handleSearch} />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ServiceRequests;